import React from 'react';
import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

enum Category {
  BestTreatmentInTown = 'best_treatment_in_town',
}

enum Property {
  BttPage = 'btt_page',
  GoToVenue = 'go_to_venue',
  GoToVenueReviews = 'go_to_venue_reviews',
  TreatmentGuide = 'treatment_guide',
  BrowsePage = 'browse_page',
}

enum Action {
  Click = 'click',
  ScrollDepth = 'scroll_depth',
}

export async function trackBttPageClick(
  event: React.SyntheticEvent<HTMLAnchorElement>,
  url: string,
  treatmentName: string,
  treatmentId: number
): Promise<void> {
  await delayRedirectionPage(
    event,
    () =>
      trackStructuredEvent({
        category: Category.BestTreatmentInTown,
        property: Property.BttPage,
        action: Action.Click,
        label: treatmentName,
        value: treatmentId,
      }),
    url
  );
}

export enum ClickTarget {
  FindOutMore = 'findOutMore',
  Caption = 'caption',
  ReviewsCount = 'reviewsCount',
}

export async function trackGoToVenueClick(
  event: React.SyntheticEvent<HTMLAnchorElement>,
  clickTarget: ClickTarget,
  venueId: number
): Promise<void> {
  const url: string = event.currentTarget.href;

  const label = {
    [ClickTarget.FindOutMore]: 'editorial_link',
    [ClickTarget.Caption]: 'editorial_link_caption',
    [ClickTarget.ReviewsCount]: 'editorial_link_reviews_count',
  }[clickTarget];

  await delayRedirectionPage(
    event,
    () =>
      trackStructuredEvent({
        category: Category.BestTreatmentInTown,
        property:
          clickTarget === ClickTarget.ReviewsCount
            ? Property.GoToVenueReviews
            : Property.GoToVenue,
        action: Action.Click,
        label,
        value: venueId,
      }),
    url
  );
}

export async function trackTreatmentGuideClick(
  event: React.SyntheticEvent<HTMLAnchorElement>,
  treatmentName: string,
  treatmentId: number
): Promise<void> {
  const url: string = event.currentTarget.href;

  await delayRedirectionPage(
    event,
    () =>
      trackStructuredEvent({
        category: Category.BestTreatmentInTown,
        property: Property.TreatmentGuide,
        action: Action.Click,
        label: treatmentName,
        value: treatmentId,
      }),
    url
  );
}

export async function trackBrowsePageClick(
  event: React.SyntheticEvent<HTMLAnchorElement>,
  treatmentName: string,
  treatmentId: number
): Promise<void> {
  const url: string = event.currentTarget.href;

  await delayRedirectionPage(
    event,
    () =>
      trackStructuredEvent({
        category: Category.BestTreatmentInTown,
        property: Property.BrowsePage,
        action: Action.Click,
        label: treatmentName,
        value: treatmentId,
      }),
    url
  );
}

async function delayRedirectionPage(
  event: React.SyntheticEvent<HTMLAnchorElement>,
  trackingFunction: () => Promise<void>,
  url: string
): Promise<void> {
  event.preventDefault();

  await trackingFunction();

  window.location.assign(url);
}

export function trackScrollDepth(depth: number, amountOfVenues: number): void {
  trackStructuredEvent({
    category: Category.BestTreatmentInTown,
    property: '',
    action: Action.ScrollDepth,
    label: depth,
    value: amountOfVenues,
  });
}
